var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFolderIconSm = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 6.30176C1.66675 4.77682 1.66675 4.01435 1.93749 3.42105C2.23734 2.76396 2.7642 2.2371 3.4213 1.93725C4.01459 1.6665 4.77706 1.6665 6.302 1.6665L6.93068 1.6665C7.29949 1.6665 7.48389 1.6665 7.65403 1.68599C8.54172 1.78767 9.3379 2.27973 9.82582 3.02824C9.91934 3.17169 10.0018 3.33663 10.1667 3.66651V3.66651C10.2767 3.88642 10.3317 3.99638 10.394 4.09202C10.7193 4.59102 11.2501 4.91906 11.8419 4.98685C11.9553 4.99984 12.0783 4.99984 12.3241 4.99984L12.6039 4.99984C14.2141 4.99984 15.0192 4.99984 15.6658 5.22827C16.8057 5.63095 17.7023 6.52757 18.105 7.66746C18.3334 8.31407 18.3334 9.11916 18.3334 10.7293L18.3334 11.9332C18.3334 14.1734 18.3334 15.2935 17.8974 16.1491C17.5139 16.9018 16.902 17.5137 16.1494 17.8972C15.2937 18.3332 14.1736 18.3332 11.9334 18.3332L8.06675 18.3332C5.82654 18.3332 4.70643 18.3332 3.85078 17.8972C3.09813 17.5137 2.48621 16.9018 2.10272 16.1491C1.66675 15.2935 1.66675 14.1734 1.66675 11.9332L1.66675 6.30176Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFolderIconSm);
export default ForwardRef;